export default __webpack_public_path__ + "static/media/enhancedWebsiteSample.a43240ee.png";